import { render, staticRenderFns } from "./AchievementsPeek.vue?vue&type=template&id=59bc0e22&"
import script from "./AchievementsPeek.vue?vue&type=script&lang=js&"
export * from "./AchievementsPeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports